import Button from '@rockalingua/ui/components/Button/Button';
import Text from '@rockalingua/ui/components/Typography/Text';
import SurveyStepOptions from '@/v2/domains/Surveys/components/SurveyStepOptions/SurveyStepOptions';
import useSubmitSurveyResponseMutation from '@/v2/domains/Surveys/queries/useSubmitSurveyResponseMutation.hook';
import useRecordSurveyImpressionMutation from '@/v2/domains/Surveys/queries/useRecordSurveyImpressionMutation.hook';

import { FooterWrapper } from './FloatingSurvey.styled';
import FloatingNotification from './components/FloatingNotification/FloatingNotification';
import MessageHeader from './components/MessageHeader/MessageHeader';
import SurveyPrimaryAction from './components/SurveyPrimaryAction/SurveyPrimaryAction';
import useFloatingSurveyVisibility from './useFloatingSurveyVisibility.hook';

export default function FloatingSurvey() {
  const { visible, survey, hide } = useFloatingSurveyVisibility();
  const { mutate: submitSurveyResponse, isPending: isSubmitting } =
    useSubmitSurveyResponseMutation({ onSuccess: hide, clearQueries: true });
  const { mutate: recordImpression } = useRecordSurveyImpressionMutation();

  if (!survey) return null;

  const { code, mode, question, description, options } = survey;

  return (
    <SurveyStepOptions
      key={code}
      mode={mode}
      options={options}
      description={description}
      size="compact"
    >
      {({ disabled, answers, content }) => (
        <FloatingNotification
          visible={visible}
          header={<MessageHeader />}
          content={
            <>
              <Text variant="grey-16-bold" color="black">
                {question}
              </Text>
              {content}
              <FooterWrapper>
                <Button
                  type="link"
                  onClick={() => {
                    recordImpression();
                    hide();
                  }}
                >
                  Skip
                </Button>
                <SurveyPrimaryAction
                  survey={survey}
                  disabled={disabled}
                  isSubmitting={isSubmitting}
                  onSubmit={() => submitSurveyResponse({ code, answers })}
                />
              </FooterWrapper>
            </>
          }
        />
      )}
    </SurveyStepOptions>
  );
}
